module.exports = __webpack_public_path__ + "img/portrait-linkedin-before.26586abb.jpg";